module.exports = __webpack_public_path__ + "img/ppt.b68eb231.png";